import { Tag, Tooltip } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCode, faFlask, faHandshake, faRobot } from '@fortawesome/free-solid-svg-icons';
import { CONNECTION_TYPES } from '@/shared/constants/connectionTypes';

export const CONNECTION_TYPE_CONFIG = {
  [CONNECTION_TYPES.AGREEMENT]: {
    color: 'blue',
    icon: faHandshake,
    label: 'Convenios',
  },
  [CONNECTION_TYPES.API]: {
    color: 'purple',
    icon: faCode,
    label: 'API',
  },
  [CONNECTION_TYPES.RPA]: {
    color: 'cyan',
    icon: faRobot,
    label: 'Bot',
  },
};

const CONNECTION_TOOLTIPS = {
  DISABLED: 'Conexión fuera de servicio o en mantenimiento',
  API_TEST: 'API (Ambiente de pruebas)',
};

/**
 * Etiqueta de tipo de conexión.
 *
 * @param {Object} props
 * @param {'agreement'|'api'|'rpa'} props.connectionType - Tipo de conexión.
 * @param {boolean} [props.testMode=false] - Indica ambiente de pruebas (solo aplica para API si compact es true).
 * @param {boolean} [props.compact=true] - Define si se muestra ícono (true) o texto (false).
 * @param {boolean} [props.globalEnabled=true] - Indica si la conexión está habilitada globalmente.
 * @param {React.ReactNode | ((baseTitle: string) => React.ReactNode)} [props.tooltip] - Permite reemplazar o modificar el contenido del tooltip.
 */
export const ConnectionTypeTag = ({
  connectionType,
  testMode = false,
  compact = true,
  globalEnabled = true,
  tooltip,
  style,
  ...tagProps
}) => {
  const connectionTypeConfig = CONNECTION_TYPE_CONFIG[connectionType] ?? null;
  if (!connectionTypeConfig) return null;

  const isApi = connectionType === CONNECTION_TYPES.API;

  // En modo compacto solo se muestra el Tag para API si testMode es true
  if (compact && isApi && !testMode) return null;

  const isApiTest = isApi && testMode;

  let tooltipTitle = globalEnabled
    ? isApiTest
      ? CONNECTION_TOOLTIPS.API_TEST
      : compact
        ? connectionTypeConfig.label
        : null
    : compact
      ? `${connectionTypeConfig.label} - ${CONNECTION_TOOLTIPS.DISABLED}`
      : CONNECTION_TOOLTIPS.DISABLED;

  // Si se pasa el prop tooltip se modifica el tooltipTitle
  if (typeof tooltip === 'function') {
    tooltipTitle = (tooltipTitle != null)
      ? tooltip(tooltipTitle)
      : null;
  } else if (tooltip !== undefined) {
    tooltipTitle = tooltip;
  }

  const color = globalEnabled
    ? isApiTest
      ? 'warning'
      : connectionTypeConfig.color
    : 'default';

  return (
    <Tooltip title={tooltipTitle} mouseEnterDelay={0.5}>
      <Tag
        color={color}
        icon={compact ? <FontAwesomeIcon icon={isApiTest ? faFlask : connectionTypeConfig.icon} /> : null}
        style={{
          margin: 0,
          ...style,
          ...(!globalEnabled && { opacity: 0.6 }),
        }}
        {...tagProps}
      >
        {!compact && connectionTypeConfig.label}
      </Tag>
    </Tooltip>
  );
};
